import type { PeriodOption } from '@repo/shared-dashboard';
import { useQuery } from '@tanstack/react-query';
import { getStaffDashboardMetrics } from './network';
import type { StaffDashboardMetrics } from './types';

export function useStaffDashboard(period: PeriodOption = 'month') {
  return useQuery<StaffDashboardMetrics>({
    queryKey: ['dashboard', 'staff-metrics', period],
    queryFn: () => getStaffDashboardMetrics(period),
    staleTime: 5 * 60 * 1000, // 5 mins
    refetchInterval: 5 * 60 * 1000, // 5 mins
  });
}
